<div class="svg-icon" [style.width.px]="width" [style.height.px]="height">
  @if (spriteLoaded && !iconExists) {
    <app-svg-icon-fallback id="testing-svg-icon-fallback" [icon]="icon" />
  } @else {
    <svg
      id="testing-icon-svg"
      [style.width.px]="width"
      [style.height.px]="height"
      [style.color]="fill"
      [class.hidden]="!iconExists"
    >
      <use attr.xlink:href="assets/sprites/sprite.svg#{{ icon }}"></use>
    </svg>
  }
</div>
